import { BaseEnum } from "../BaseEnum";

export class DocumentTypes extends BaseEnum {
  static ENTERPRISE = 1;
  static PROJECT = 2;
  static OTHER = 3;
  static ESG = 4;
  static ESG_DOCUMENTATION = 5;
  static ESG_FINAL_DOCUMENTATION = 6;
  static DSR_UPLOAD = 7;

  static Codes = [
    this.ENTERPRISE,
    this.PROJECT,
    this.OTHER,
    this.ESG,
    this.ESG_DOCUMENTATION,
    this.ESG_FINAL_DOCUMENTATION,
    this.DSR_UPLOAD,
  ];

  static _labelKeys = [
    "enterprise",
    "project",
    "other",
    "esg.default",
    "esg.documentation",
    "esg.final-documentation",
    "dsr.upload-file",
  ];
}
